import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader2 } from 'lucide-react';
import { changeLanguage } from '../../slices/languageSlice';
import i18n from 'i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español (Spanish)' },
  { code: 'fr', label: 'Français (French)' },
  { code: 'de', label: 'Deutsch (German)' },
  { code: 'zh', label: '中文 (Chinese)' },
  { code: 'ja', label: '日本語 (Japanese)' },
  { code: 'ko', label: '한국어 (Korean)' },
  { code: 'hi', label: 'हिन्दी (Hindi)' },
  { code: 'ar', label: 'العربية (Arabic)' },
  { code: 'pt', label: 'Português (Portuguese)' },
  { code: 'ru', label: 'Русский (Russian)' },
  { code: 'it', label: 'Italiano (Italian)' },
  { code: 'vi', label: 'Tiếng Việt (Vietnamese)' },
  { code: 'tr', label: 'Türkçe (Turkish)' },
  { code: 'tl', label: 'Tagalog' },
  { code: 'sw', label: 'Kiswahili (Swahili)' },
  { code: 'bn', label: 'বাংলা (Bengali)' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'ur', label: 'اردو (Urdu)' },
  { code: 'am', label: 'አማርኛ (Amharic)' },
];

/**
 * LanguageSwitcher - List of language options
 * Matches the reference project styling
 */
const LanguageSwitcher = () => {
  const [loading, setLoading] = useState(false);
  const [loadingLang, setLoadingLang] = useState(null);
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => state.language.language);

  const handleLanguageChange = async (lang) => {
    if (lang === currentLanguage || loading) return;
    
    setLoading(true);
    setLoadingLang(lang);
    dispatch(changeLanguage(lang));
    await i18n.changeLanguage(lang);
    setLoading(false);
    setLoadingLang(null);
  };

  return (
    <div className="space-y-2 max-h-96 overflow-y-auto">
      {languages.map((lang) => {
        const isSelected = currentLanguage === lang.code;
        const isLoading = loadingLang === lang.code;
        
        return (
          <button
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            disabled={loading}
            className={`
              w-full px-4 py-3 rounded-xl text-left transition-colors min-h-[48px]
              flex items-center justify-between
              ${isSelected
                ? 'bg-primary text-white font-semibold'
                : 'bg-gray-50 text-foreground hover:bg-gray-100'
              }
              ${loading && !isLoading ? 'opacity-50' : ''}
            `}
          >
            <span>{lang.label}</span>
            {isLoading && (
              <Loader2 className="w-4 h-4 animate-spin" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
